export const ROLES = ["DSE", "SalesManager", "PDI", "Accounts", "BackOffice", "Spares", "Admin"];

export const ROLE_LABELS = {
  DSE: "Sales Executive",
  SalesManager: "Sales Manager",
  PDI: "PDI Team",
  Accounts: "Accounts",
  BackOffice: "Back Office",
  Spares: "Spares",
  Admin: "Admin",
};

export const SALE_STATUS_LABELS = {
  draft: "Draft",
  submitted: "Submitted",
  in_progress: "In Progress",
  ready_for_delivery: "Ready for Delivery",
  delivered: "Delivered",
  transit_hold: "Transit Hold",
};

export const SALE_STATUS_TONE = {
  draft: "neutral",
  submitted: "warning",
  in_progress: "warning",
  ready_for_delivery: "success",
  delivered: "success",
  transit_hold: "info",
};

export const TASK_STATUS_TONE = {
  pending: "danger",
  completed: "success",
};

// Canonical task type catalogue — kept aligned with backend TASK_TYPES.
export const TASK_TYPE_LABELS = {
  PDI_VIN: "VIN Assignment",
  PDI_READY: "Vehicle Readiness",
  ACCOUNTS_INVOICE: "Tax Invoice",
  INSURANCE: "Insurance",
  ROAD_TAX: "Road Tax",
  HSRP: "HSRP",
  VAS_PP: "Protection Plus",
  VAS_AMC: "AMC",
  VAS_RSA: "RSA",
  SPARES: "Spares · Accessories",
};

// Display order for the timeline strip on Sale Detail / Sales List.
export const TASK_TIMELINE_ORDER = [
  "PDI_VIN",
  "ACCOUNTS_INVOICE",
  "INSURANCE",
  "ROAD_TAX",
  "HSRP",
  "VAS_PP",
  "VAS_AMC",
  "VAS_RSA",
  "PDI_READY",
  "SPARES",
];

// Tasks that gate `ready_for_delivery` — must mirror backend DELIVERY_REQUIRED_TASKS.
export const DELIVERY_REQUIRED_TASKS = [
  "PDI_READY", "ACCOUNTS_INVOICE", "INSURANCE", "ROAD_TAX", "HSRP",
];

export const VEHICLE_MODELS = [
  "MT-15",
  "R15 V4",
  "R15M",
  "FZ-X",
  "FZ-S Fi V4",
  "FZS 25",
  "MT-03",
  "Aerox 155",
  "Ray ZR 125 Fi",
  "Fascino 125 Fi",
];

export const FINANCE_TYPES = [
  { value: "cash", label: "Cash" },
  { value: "finance", label: "Finance" },
];
